import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const VisionIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 255 255" {...rest} __css={styles}>
      <desc id="svgdescVision">eye</desc>
      <circle className="accent" cx="127.5" cy="127.5" r="127.5" />
      <path
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
        d="M182.1 93.5c-.3-.2-.5-.5-.9-.4l-.1.2.3 1.1a57 57 0 0 1-60.6 73.9 54.4 54.4 0 0 1-36.5-19.4 55.5 55.5 0 0 1-10.8-54.7c.1-.3.3-.6.1-.8-.3-.2-.5.1-.8.2l-.4.2a107.5 107.5 0 0 0-33.3 32.8c-.5.7-.4 1.2 0 1.9a105.5 105.5 0 0 0 104 47.2c31-5 54.9-21.2 72.3-47.1.6-.8.6-1.5 0-2.3a106.4 106.4 0 0 0-33.3-32.8z"
      />
      <path
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
        d="M106.2 126.1c11.6 0 21.2-9.5 21.2-21.2 0-11.6-9.5-21.2-21.1-21.2a21.2 21.2 0 0 0-21.1 21.1 21 21 0 0 0 21 21.3z"
      />
      <path
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
        d="M127.5 0a127.5 127.5 0 1 0 0 255 127.5 127.5 0 0 0 0-255zm112.9 128.4a131.2 131.2 0 0 1-53.7 55 124.3 124.3 0 0 1-114 2.3 125.6 125.6 0 0 1-53.2-48.6c-1.9-3-3.5-6.2-5.3-9.3v-.6l.6-1.1a129.4 129.4 0 0 1 62.5-59c12-5.3 24.4-8.6 37.4-9.8l6.3-.6h13l1 .2a125.4 125.4 0 0 1 83.8 39.2c6.9 7.2 12.8 15 17.8 23.6l4.3 7.6v.4a3 3 0 0 0-.5.7z"
      />
    </Icon>
  );
};

export default VisionIcon;
